// extracted by mini-css-extract-plugin
module.exports = {"root":"CommonTextarea_root__jIJRn","error":"CommonTextarea_error__kbNr_","textarea":"CommonTextarea_textarea__5WUO3","hidden":"CommonTextarea_hidden__QAPtA"};